
import { PrimaryBeneficiary } from 'ApplicationEntry/models/PrimaryBeneficiary';
import { PrimaryBeneficiaryList } from 'ApplicationEntry/models/PrimaryBeneficiaryList';
import * as I from 'immutable';
import { createAction } from 'Shared/utilities/actionCreator';
import { reverseEnum } from 'Shared/utilities/enumUtility';
import * as P from '../models/PrimaryBeneficiaryList';

export enum PrimaryBeneficiaryListActionType {
  ADD_PRIMARYBENEFICIARY = 'primaryBeneficiary/ADD_PRIMARYBENEFICIARY',
  REMOVE_PRIMARYBENFICIARY = 'primaryBeneficiary/REMOVE_PRIMARYBENEFICIARY',
  UPDATE_PRIMARYBENEFICIARY = 'primaryBeneficiary/UPDATE_PRIMARYBENEFICIARY'
}

export const addPrimaryBeneficiary = (primaryBeneficiary: I.List<PrimaryBeneficiary>) => {
  return createAction(PrimaryBeneficiaryListActionType.ADD_PRIMARYBENEFICIARY, { primaryBeneficiary });
};

export const removePrimaryBeneficiary = (index: number) => {
  return createAction(PrimaryBeneficiaryListActionType.REMOVE_PRIMARYBENFICIARY, {index});
};

export const updatePrimaryBeneficiary = (primaryBeneficiary: PrimaryBeneficiary, index: number) => {
  return createAction(PrimaryBeneficiaryListActionType.UPDATE_PRIMARYBENEFICIARY, {primaryBeneficiary, index});
};

export type PrimaryBeneficiaryListAction = 
      | ReturnType<typeof addPrimaryBeneficiary>
      | ReturnType<typeof removePrimaryBeneficiary>
      | ReturnType<typeof updatePrimaryBeneficiary>

export const isPrimaryBeneficiaryListAction = (action: any): action is PrimaryBeneficiaryListAction =>
  action.type in reverseEnum(PrimaryBeneficiaryListActionType);

type PrimaryBeneficiaryListState = PrimaryBeneficiaryList;
const DEFAULT_STATE: PrimaryBeneficiaryListState = P.EmptyPrimaryBeneficiaryList;

export default (state: PrimaryBeneficiaryListState = DEFAULT_STATE, action: PrimaryBeneficiaryListAction): PrimaryBeneficiaryListState => {
  switch (action.type) {
    case PrimaryBeneficiaryListActionType.ADD_PRIMARYBENEFICIARY:
        const { primaryBeneficiary } = action.payload;
        return P.addPrimaryBeneficiary(primaryBeneficiary)(state.primaryBeneficiaryList);
      case PrimaryBeneficiaryListActionType.REMOVE_PRIMARYBENFICIARY:
        return P.removePrimaryBeneficiary(action.payload.index)(state.primaryBeneficiaryList);
      case PrimaryBeneficiaryListActionType.UPDATE_PRIMARYBENEFICIARY:
        return P.updatePrimaryBeneficiary(action.payload.primaryBeneficiary, action.payload.index)(state.primaryBeneficiaryList);
    default:
      return state;
  }
};